import { render, staticRenderFns } from "./BankListModal.vue?vue&type=template&id=27b8bece&"
import script from "./BankListModal.vue?vue&type=script&lang=js&"
export * from "./BankListModal.vue?vue&type=script&lang=js&"
import style0 from "./BankListModal.vue?vue&type=style&index=0&id=27b8bece&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports